import { Form, Input, Button, Checkbox, InputNumber } from "antd";
import Axios from "axios";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Label } from "reactstrap";
import BackComponent from "../BackComponent";
import { UserContext } from "../userComponents/UserContext";

const FormTableGames = (props) => {
  const [user] = useContext(UserContext);
  const history = useHistory();
  const [form] = Form.useForm();
  const [formLayout] = useState("horizontal");

  const handleSubmit = (values) => {
    let singlePlayer = values.mode.includes("one") ? 1 : 0;
    let multiPlayer = values.mode.includes("two") ? 1 : 0;

    const newData = {
      name: values.name,
      genre: values.genre,
      singlePlayer: singlePlayer,
      multiplayer: multiPlayer,
      platform: values.platform,
      release: values.release,
      image_url: values.image_url,
    };
    console.log(newData, " cek values");

    const url = `https://backendexample.sanbersy.com/api/data-game`;
    Axios.post(url, newData, {
      headers: { Authorization: `Bearer ${user.token}` },
    })
      .then((res) => {
        alert("Data Berhasil Masuk");
        history.push("/games");
        console.log(res.response);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  return (
    <Container>
      <Row>
        <Col md="8" className="mx-auto mt-5">
          <Form
            layout={formLayout}
            form={form}
            initialValues={{
              layout: formLayout,
            }}
            onFinish={handleSubmit}
          >
            <Form.Item label="Name" name="name">
              <Input placeholder="input Name" />
            </Form.Item>
            <Form.Item label="Genre" name="genre">
              <Input placeholder="input Genre" />
            </Form.Item>
            <Form.Item name="mode">
              <Checkbox.Group style={{ width: "100%" }}>
                <Row>
                  <Col span={8}>
                    <Label>SinglePlayer : </Label>
                    <Checkbox value="one" />
                  </Col>
                  <Col span={8}>
                    <Label>MultiPlayer : </Label>
                    <Checkbox value="two" />
                  </Col>
                </Row>
              </Checkbox.Group>
            </Form.Item>
            <Form.Item label="Platform" name="platform">
              <Input placeholder="input Platform" />
            </Form.Item>
            <Form.Item label="Release" name="release">
              <InputNumber placeholder="input Release" />
            </Form.Item>
            <Form.Item label="Image_Url" name="image_url">
              <Input placeholder="input Image_Url" />
            </Form.Item>
            <Button type="primary" htmlType="submit" className="primary mb-2">
              Submit
            </Button>
            <BackComponent />
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default FormTableGames;
